export interface IAppConfig {
  LocalStorageKey: Record<string, string>;
  CookieKey: Record<string, string>;
}

export class AppConfig implements IAppConfig {
  private static _instance: IAppConfig;
  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  readonly LocalStorageKey = {
    accessToken: "t__wmx_access_token",
    loggedInUser: "t__wmx_logged_in_user",
    maintenanceClosedTime: "t__wmx_maintenance_closed_time",
  };

  readonly CookieKey = {
    accessToken: "t__wmx_access_token",
  };
}
